import { defineEvent } from "../types/event";
export var FILTER_OPTION_DESELECT = defineEvent({
    platforms: [
        {
            name: "Optimizely",
            alias: "Filter_option_deselected"
        }
    ]
});
